<script setup>
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import DomainPrompt from '../../components/DomainPrompt.vue';

const store = useStore();
const router = useRouter();
const route = useRoute();

const loading = ref(true);

onMounted(async () => {
  try {
    await store.dispatch('users/login');
    if (route.redirectedFrom) {
      router.replace(route.redirectedFrom);
    } else {
      router.push('/');
    }
  } catch (err) {
    // User not logged in
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <div class="flex flex-grow">
    <domain-prompt v-show="!loading" />
    <div
      v-show="loading"
      class="
        absolute
        top-0
        left-0
        flex
        h-full
        w-full
        items-end
        justify-end
        bg-gray-900 bg-opacity-70
        p-20
        text-2xl text-brand-400
      "
    >
      <span class="animate-pulse"> Checking for existing session </span>
    </div>
  </div>
</template>
